import { Component, OnInit, ViewChild } from '@angular/core';
import { ClientDetails, DdDispatchDetails, DdDispatchDetailsService,PtdClientService,PtdDispatchDetails,PtdDispatchService, DeadlineUpdate, SplitWarehouse, Warehouse } from 'coadapi';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { NotesDialogComponent } from './pages/dialogs/notes-dialog/notes-dialog.component';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogCompleteService, DDActionService } from '../proforma-to-dispatch/abstracts/_datasharing';
import Utils from './abstracts/_utils';
import { startWith, switchMap } from 'rxjs/operators';
import { IwdDeadlineComponent } from '../dialogs/iwd-deadline/iwd-deadline.component';
import { CustomDateAdapter } from '../proforma-to-dispatch/abstracts/_date-adapter';

@Component({
  selector: 'app-dispatch-details',
  templateUrl: './dispatch-details.component.html',
  styleUrls: ['./dispatch-details.component.scss']
})
export class DispatchDetailsComponent implements OnInit {
  @ViewChild(CdkVirtualScrollViewport, { static: true })
  dispatchDetails: DdDispatchDetails[] = [];
  selectedDispatch?: DdDispatchDetails; // selected dispatch
  ptdDispatchDetail: PtdDispatchDetails = {};
  randomPhrase = Utils.randomPhrase;
  lastSort = "";
  orderVar = '';
  orderMod = false;
  orderDir = '';
  sortBy = '';
  // Caches the IWD determination for dispatches that have been opened, so the
  // list rows (which only carry DdDispatchDetails, with no IWD field) can
  // reflect return legs once the dispatch has been loaded once.
  private iwdStateCache = new Map<number, boolean>();

  private toDispatchIsoDate(date: Date): string {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())).toISOString();
  }
  
  constructor(
    private dispatchDetailsService: DdDispatchDetailsService,
    private clientService: PtdClientService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private dialogCompleteService: DialogCompleteService,
    private ptdDispatchService: PtdDispatchService,
    public ddActionService: DDActionService,
  ) {
    this.iconRegistry.addSvgIcon('edit-pen', this.sanitizer.bypassSecurityTrustResourceUrl('app/coad-web/proforma-to-dispatch/images/editsvg.svg'));
    this.iconRegistry.addSvgIcon('looking-glass', this.sanitizer.bypassSecurityTrustResourceUrl('app/coad-web/proforma-to-dispatch/images/contentssvg.svg'));
    this.iconRegistry.addSvgIcon('iwdr', this.sanitizer.bypassSecurityTrustResourceUrl('app/coad-web/proforma-to-dispatch/images/iwdrsvg.svg'));
  }
  

  sharingDispatchData(
    ddDispatch: DdDispatchDetails[],    
    index: number
  ) {
    this.selectedDispatch = ddDispatch[index];
    const dispatchId = this.selectedDispatch?.dispatchId;
    const warehouseId = this.selectedDispatch?.warehouseId;
    if (typeof dispatchId !== 'number' || typeof warehouseId !== 'number') {
      return;
    }
    this.ptdDispatchService.getDispatch(dispatchId, warehouseId).subscribe((ptdDispatch: PtdDispatchDetails | PtdDispatchDetails[]) => {
      if (!ptdDispatch) {
        return;
      }

      // The API returns a single-element array; the generated client types it as a single object.
      this.ptdDispatchDetail = Array.isArray(ptdDispatch) ? ptdDispatch[0] : ptdDispatch;
      if (!this.ptdDispatchDetail) {
        return;
      }

      const needsIwd = this.dispatchNeedsIwd(this.ptdDispatchDetail);
      if (typeof this.ptdDispatchDetail.dispatchId === 'number') {
        this.iwdStateCache.set(this.ptdDispatchDetail.dispatchId, needsIwd);
      }

      if (needsIwd) {
        this.openIWDDeadlineDialog(this.ptdDispatchDetail, this.ptdDispatchDetail.dispatchProformas ?? []);
      } else {
        const clientId = this.ptdDispatchDetail.modelClient?.clientId;
        if (typeof clientId !== 'number') {
          return;
        }
        let client: ClientDetails;
        this.clientService.getOneClient(clientId).subscribe((res) => {
        client = res;
        this.router.navigate(['dispatch'], {
          relativeTo: this.route,
          skipLocationChange: false,
          state: {
            ptdDispatch: this.ptdDispatchDetail,
            clientDetails: client
          }
          });
        }); 
      }
    });
  }
  
  /**
   * Opens the content dialog.
   *
   * @param {number} destination - The destination value.
   * @param {number} dispatchId - The dispatch ID value.
   * @param {number} tabIndex - The tab index value.
   * @return {void} This function does not return a value.
   */
  openContentDialog(destination: number, dispatchId: number, tabIndex: number): void {
    this.router.navigate(['contents'], {
      relativeTo: this.route,
      skipLocationChange: true,
      queryParams: {
        destination: destination,
        dispatchId: dispatchId,
        tabIndex: tabIndex
      }
    });
  }

  openIwdContentDialog(dispatchId: number): void {
    this.router.navigate(['iwd-contents'], {
      relativeTo: this.route,
      skipLocationChange: true,
      queryParams: {
        dispatchId: dispatchId
      }
    });
  }

  ngOnInit(): void {
    this.ddActionService.ddAction$.pipe(
      startWith(void 0),
      switchMap(() => {
        return this.dispatchDetailsService.ddGetDispatchDetails()
      })
    ).subscribe((dispatchDetails) => {
      this.dispatchDetails = dispatchDetails;
    });
    // subscribe to the dialogcomplete subject to watch for the completed dialog close
    this.dialogCompleteService.dialogComplete$.subscribe({
      next: (result: boolean) => {
        if (result === true) {
          this.ddActionService.ddAction$.next(void 0);
        }
      }
    })
  }

  // ngAfterViewInit() {
  //   this.getData();
  // }

  onImgError(event: Event) {
    (event.target as HTMLImageElement).src = this.orderDir + '.png';
  }

  sort(sort: string) {
    if (this.dispatchDetails) {
      this.sortBy = sort;
      if (this.sortBy === this.lastSort) {
        this.orderMod = !this.orderMod;
      } else {
        this.orderMod = false;
      }
      this.lastSort = sort;
      // this.orderMod = !this.orderMod;
      if (this.orderMod) {
        this.orderVar = this.sortBy;
        this.orderDir = 'up';
      } else {
        this.orderVar = '-' + this.sortBy;
        this.orderDir = 'down';
      }
      this.dispatchDetails = [...this.dispatchDetails.sort(
        (a, b) => (a as any)[this.orderVar] > (b as any)[this.orderVar] ? 1 : -1
      )];
    }
  }

  // getData() {
  //   this.dispatchDetailsService.ddGetDispatchDetails().subscribe((dispatchDetails) => {
  //     this.dispatchDetails = dispatchDetails;
  //   })
  // }

  openNotesDialog(id: number) {
    const notesRef = this.dialog.open(NotesDialogComponent, {
      id: "notes-dialog",
      width: "600px",
      disableClose: false,
      panelClass: "confirmation-pane",
      data: {
        tableName: "dispatch",
        id: id
      },
    });
  }

  openIWDDeadlineDialog(
    originDispatch: PtdDispatchDetails,
    iwds: Array<SplitWarehouse>
  ) {
    const originWarehouseId = originDispatch.dispatchWarehouse?.warehouseId;
    if (typeof originWarehouseId !== 'number') {
      return;
    }
    const distinctWarehouses = this.countIwdWarehouses(
      iwds,
      originWarehouseId,
      originDispatch.dispatchIwds
    );
    const iwdDeadlineRef = this.dialog.open(IwdDeadlineComponent, {
      id: "iwd-deadline-dialog",
      width: "600px",
      disableClose: false,
      panelClass: "confirmation-pane",
      data: {
        distinctWarehouses: distinctWarehouses,
        dispatch: originDispatch,
        warehouse: originWarehouseId,
      },
    });
    iwdDeadlineRef.afterClosed().subscribe((res) => {
      if (res) {
        res.forEach((element: { index: number; selectedRangeValue: { start: Date; end: Date } }) => {
          if (element.index > 0){
            const utcEts = CustomDateAdapter.changeDateToFlatDate(element.selectedRangeValue.start)
            const utcEta = CustomDateAdapter.changeDateToFlatDate(element.selectedRangeValue.end)
            const iwdDeadline = <DeadlineUpdate>{
              dispatchId: originDispatch.dispatchId,
              warehouseId: element.index,
              ets: this.toDispatchIsoDate(utcEts),
              eta: this.toDispatchIsoDate(utcEta),
            };
            this.ptdDispatchService.setIWDDeadline(iwdDeadline).subscribe({
              next: (result: any) => {
                console.log(result);
                this.ddActionService.ddAction$.next(void 0);
              },
              complete: () => {
                console.log("update complete");
                return true;
              },
            });
          }
        });
      }
    });
  }

  /**
   * Determines whether a dispatch needs IWD handling. The origin/destination
   * comparison alone misses return legs (e.g. UK -> US -> UK) where both
   * warehouses are the same, so also check the backend-computed flag and any
   * linked IWD dispatches.
   */
  dispatchNeedsIwd(dispatch: PtdDispatchDetails): boolean {
    if (!dispatch) {
      return false;
    }
    if (dispatch.dispatchWarehouse?.warehouseId !== dispatch.shippedToWarehouse?.warehouseId) {
      return true;
    }
    if (dispatch.hasIwd === true) {
      return true;
    }
    return (dispatch.dispatchIwds?.length ?? 0) > 0;
  }

  /**
   * Row-level IWD indicator for the dispatch list. Prefers the backend's
   * derived hasIWD flag (correct for return legs where origin === destination),
   * then the cached result once the dispatch has been loaded, and finally the
   * origin/destination comparison as a fallback for older backends.
   */
  rowNeedsIwd(dispatchDetail: DdDispatchDetails): boolean {
    if (!dispatchDetail) {
      return false;
    }
    if (dispatchDetail.HasIwd === true) {
      return true;
    }
    const cached = typeof dispatchDetail.dispatchId === 'number'
      ? this.iwdStateCache.get(dispatchDetail.dispatchId)
      : undefined;
    if (cached !== undefined) {
      return cached;
    }
    return dispatchDetail.shippedTo !== dispatchDetail.leavingFrom;
  }

  countIwdWarehouses(
    iwds: Array<SplitWarehouse>,
    originWarehouse: number,
    dispatchIwds?: Array<PtdDispatchDetails>
  ): Array<Warehouse> {
    let distinctWarehouse: Array<Warehouse> = [];
    const addWarehouse = (warehouse: Warehouse | undefined) => {
      if (!warehouse || typeof warehouse.warehouseId !== 'number' || warehouse.warehouseId === 5) {
        return;
      }
      if (distinctWarehouse.find((x) => x.warehouseId === warehouse.warehouseId)) {
        return;
      }
      if (warehouse.warehouseId === originWarehouse) {
        distinctWarehouse.splice(0, 0, warehouse);
      } else {
        distinctWarehouse.push(warehouse);
      }
    };
    (iwds ?? []).forEach((iwd) => addWarehouse(iwd.warehouse));
    // Return legs (e.g. UK -> US -> UK) can have splits that all match the
    // origin warehouse; the linked IWD dispatches carry the real warehouses.
    (dispatchIwds ?? []).forEach((iwdDispatch) => {
      addWarehouse(iwdDispatch.dispatchWarehouse);
      addWarehouse(iwdDispatch.shippedToWarehouse);
    });
    return distinctWarehouse;
  }
}


